import axios from "axios";
import { isNullOrUndefined } from "./utils";
const baseDaoURL = process.env.REACT_APP_API_BASE_URL;
let ipData = await axios.get("https://api.ipify.org/?format=json");

export const daoPostMethod = async (api, payload) => {
  let localStorageKey = localStorage.getItem("token");

  const postData = await axios.post(baseDaoURL + api, payload, {
    headers: {
      Authorization: `${localStorageKey}`,
      "x-access-token": `${localStorageKey}`,
      "P-DeviceType": "web",
      "P-ClientPublicIP": ipData?.data?.ip,
      ClientType: "client",
    },
  });

  return postData ? postData.data : null;
};
// export const paymentPostMethod = async (api, payload) => {
//   let localStorageKey = localStorage.getItem("token");

//   const postData = await axios.post(basePaymentURL + api, payload, {
//     headers: {
//       Authorization: `${localStorageKey}`,
//       "P-Appname": "dao",
//     },
//   });

//   return postData ? postData.data : null;
// };

export const daoPostMethodForUpload = async (url, data) => {
  let localStorageKey = localStorage.getItem("token");
  const postData = await axios.post(baseDaoURL + url, data, {
    headers: {
      Authorization: `${localStorageKey}`,
      "x-access-token": `${localStorageKey}`,
      "P-DeviceType": "web",
      ClientType: "client",
      "Content-Type": "multipart/form-data",
    },
  });
  return postData ? postData.data : null;
};

export const getMethod = async (api, payload) => {
  let localStorageKey = localStorage.getItem("token");
  let getData;
  if (isNullOrUndefined(payload)) {
    getData = await axios.get(baseDaoURL + api, {
      headers: {
        Authorization: `${localStorageKey}`,
        "x-access-token": `${localStorageKey}`,
        "P-DeviceType": "web",
        ClientType: "client",
      },
    });
  } else {
    getData = await axios.get(baseDaoURL + api, payload, {
      headers: {
        Authorization: `${localStorageKey}`,
        "x-access-token": `${localStorageKey}`,
        "P-DeviceType": "web",
        ClientType: "client",
      },
    });
  }

  return getData ? getData.data : null;
};
export const getMethodWithQuery = async (api, query) => {
  // if (cancelToken) {
  //   cancelToken.cancel();
  // }

  // cancelToken = axios.CancelToken.source();
  let localStorageKey = localStorage.getItem("token");

  const getData = await axios.get(
    baseDaoURL + api,

    {
      headers: {
        Authorization: `${localStorageKey}`,
        "P-DeviceType": "web",
        ClientType: "client",
      },
      params: query,
      // cancelToken: cancelToken.token,
    }
  );

  return getData ? getData.data : null;
};
